import React from 'react';
import styled from 'styled-components';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapPin } from '@fortawesome/pro-light-svg-icons';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import SearchResult from 'npo/pages/ReportBuilder/Components/Location/SearchResult';

const AutoComplete = styled.div`
  margin-top: ${SPACERS.medium};
  .result-label {
    line-height: 1;
    margin-bottom: ${SPACERS.tiny};
  }
`;

const ResultsGroup = styled.div`
  margin-bottom: ${SPACERS.small};
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  font-size: 16px;
`;

interface SearchAutocompleteProps {
  className?: string;
  location?: string;
}

const SearchAutocomplete: React.FC<SearchAutocompleteProps> = ({ className, children }) => {
  return (
    <AutoComplete>
      <ResultsGroup>
        <TrueImpactText variant='heading-label' className='result-label'>Cities</TrueImpactText>
        <SearchResult location='Dallas, TX'/>
        <SearchResult location='Dallas, GA'/>
      </ResultsGroup>
      <ResultsGroup>
        <TrueImpactText variant='heading-label' className='result-label'>States</TrueImpactText>
        <SearchResult location='Texas'/>
        <SearchResult location='Georgia'/>
      </ResultsGroup>
      <ResultsGroup>
        <TrueImpactText variant='heading-label' className='result-label'>Countries</TrueImpactText>
        <SearchResult location='United States of America'/>
      </ResultsGroup>
    </AutoComplete>
  );
};

export default SearchAutocomplete;
